// Local Imports
import Logo from "app/presentation/assets/appLogo.svg?react";
import { Progress } from "@ui/index.js";

// ----------------------------------------------------------------------

export function SplashScreen() {
  return (
    <div className="fixed inset-0 grid place-content-center bg-white dark:bg-dark-900 z-[9999] overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-20 dark:opacity-10 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary-500/20 rounded-full blur-[120px] animate-pulse"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-indigo-500/20 rounded-full blur-[120px] animate-pulse delay-700"></div>
      </div>

      <div className="flex flex-col items-center relative z-10">
        <div className="relative group">
          <Logo className="size-32 text-primary-600 dark:text-primary-400 transition-transform duration-700 group-hover:scale-110" />
          <div className="absolute -inset-4 bg-primary-500/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
        </div>

        <div className="w-56 mt-12 bg-gray-100 dark:bg-dark-700 rounded-full overflow-hidden p-0.5 border border-gray-200/50 dark:border-dark-600/50 shadow-inner">
          <Progress
            color="primary"
            isIndeterminate
            animationDuration="1.5s"
            className="h-1.5 rounded-full"
          />
        </div>

        <div className="mt-8 flex flex-col items-center gap-2">
          <p className="text-[11px] font-black uppercase tracking-[0.5em] text-gray-900 dark:text-white opacity-80 animate-pulse">
            Initialisation TxApp
          </p>
          <div className="h-0.5 w-8 bg-primary-500 rounded-full"></div>
        </div>
      </div>
    </div>
  );
}
